export default function () {
    return {
      dataOwner: null
    }
  }